export default function HowItWorks() {
  const steps = [
    {
      title: 'Formação Híbrida',
      description: 'Presencial obrigatório com suporte online complementar para acompanhamento contínuo'
    },
    {
      title: 'Turmas Reduzidas',
      description: 'Grupos pequenos para atenção individualizada e desenvolvimento personalizado'
    },
    {
      title: 'Vivências Práticas',
      description: 'Práticas em cena, estúdio, treino ou ambiente esportivo com aplicação real'
    },
    {
      title: 'Equilíbrio Integral',
      description: 'Processos de equilíbrio emocional e energético para performance sustentável'
    },
    {
      title: 'Práticas Avançadas',
      description: 'Telepatia, foco, respiração e disciplina interna aplicados ao seu campo de atuação'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <h2 className="text-4xl lg:text-5xl font-black text-[#262364] mb-6">
            Como Funciona
          </h2>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto">
            Um processo estruturado para garantir sua evolução constante e resultados mensuráveis
          </p>
        </div>

        <div className="relative">
          {/* Vertical Line */}
          <div className="hidden lg:block absolute left-1/2 top-0 bottom-0 w-1 bg-[#F05954] transform -translate-x-1/2"></div>

          {/* Timeline Items */}
          <div className="space-y-16">
            {steps.map((step, index) => (
              <div
                key={index}
                className={`relative flex items-center ${
                  index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                }`}
              >
                {/* Circle */}
                <div className="hidden lg:flex absolute left-1/2 transform -translate-x-1/2 w-16 h-16 rounded-full bg-[#262364] items-center justify-center z-10 shadow-lg">
                  <span className="text-white text-xl font-black">{index + 1}</span>
                </div>

                {/* Content Card */}
                <div
                  className={`w-full lg:w-5/12 ${
                    index % 2 === 0 ? 'lg:pr-16 lg:text-right' : 'lg:pl-16 lg:text-left'
                  }`}
                >
                  <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-md hover:shadow-xl transition-all duration-300 border-l-4 border-[#F05954]">
                    {/* Mobile Circle */}
                    <div className="lg:hidden w-12 h-12 rounded-full bg-[#262364] flex items-center justify-center mb-4">
                      <span className="text-white text-lg font-black">{index + 1}</span>
                    </div>
                    
                    <h3 className="text-xl font-bold text-[#262364] mb-3">
                      {step.title}
                    </h3>
                    <p className="text-sm text-gray-600 leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
